var map = {
	"./alert-attention.svg": 3,
	"./alert-example.svg": 4,
	"./alert-new.svg": 5,
	"./alert-tip.svg": 6,
	"./alert-warning.svg": 7,
	"./arrow-thin.svg": 8,
	"./arrow.svg": 9,
	"./close.svg": 10,
	"./file-excel.svg": 11,
	"./file-excel2.svg": 12,
	"./file-image.svg": 13,
	"./file-pdf.svg": 14,
	"./file-word.svg": 15,
	"./file-zip.svg": 16,
	"./file.svg": 17,
	"./hamburger.svg": 18,
	"./home.svg": 19,
	"./link.svg": 20,
	"./pause.svg": 21,
	"./play.svg": 22,
	"./product_aemter_und_behoerden.svg": 23,
	"./product_akkreditierung.svg": 24,
	"./product_app.svg": 25,
	"./product_app_2.svg": 26,
	"./product_formulare.svg": 27,
	"./product_fotoservice.svg": 28,
	"./product_geld.svg": 29,
	"./product_gesetze.svg": 30,
	"./product_login.svg": 31,
	"./product_newsletter.svg": 32,
	"./product_publikationen.svg": 33,
	"./product_rechner.svg": 34,
	"./product_services.svg": 35,
	"./product_statistik.svg": 36,
	"./product_videoservice.svg": 37,
	"./sample.svg": 38,
	"./search.svg": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;